export function isEmbeddedDocument(): boolean {
  return window.top !== window.self;
}

// @ts-ignore: This actually exists on IE 6-11
export const isIE = () => !!document.documentMode;



// WEBPACK FOOTER //
// ./app/common/lib/util/browser.ts